/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![SoundboardSlashIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB8ElEQVR4nM1Uu0rEUBDNoqBiJfjADxB7OxtXECGwuTOzynVuVLDTLxBtFC1FsRC010L9BdsVn2jhHyz4+AARLJVJbjQmu9mHKziQInNvzjmZMzOO8x9DId8AmttKZ57n9wKaMyDeqg1E5gKQLx3HyUU5AD0MZD4U8XNFcOIHOReSmgSAXJbLHvmjUQ7RXwoB+LgqOPGDvNfxB7xr1e5+5dCc2NxilHO17msYPFBF/qhVW46RPkuuMOUPNa08FjnxQZEpfROYkkJeawV4ZrjNlEVr3QXE+wr5EYjfpBUVmk2lzED8XtPKgXgn/CjxIL8Xi3ODWeDiiRgv3aWQXxTxXYpADoIPYWYsv7DQ6SFPKDKnCnklC1w8SYsyVz/AC4XZnuhQSpUk9zLKYo1/EfXBnIAeTqn3ijMjEYEob0nN4+GhPx2r+XEt8KL1pO4A4uXvGvJqFrhCXgmNn++P7ayyTLxdK7k0AZqDYAUgb2SBS4jx8buyEOMGC6GTDCBzBMTr9dTcQ56w++japnKiPNhdsiCRz1MEjRg6OTnfbZW+VgVqBByIV8V4US4tjMjjySXYNLhC3qg43eG9vd8qX68EbFf2tkx7TXCtdRugua/SLYdhd/GyzIkMo0x83WWRcF23A8g8CUlL93mSJJ/Pt/8F+CeweIrmfMSofgAAAABJRU5ErkJggg==)
 */
export const SoundboardSlashIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M17.15 10.85c-.1.1-.16.23-.13.36a1 1 0 0 0 1.22.76l4-1a1 1 0 1 0-.48-1.94l-3.58.9a.5.5 0 0 0-.24.13l-.8.8ZM13.94 6.06a.5.5 0 0 0 .13-.24l.9-3.58a1 1 0 1 0-1.94-.48l-1 4a1 1 0 0 0 .76 1.22c.13.03.26-.03.36-.13l.8-.8ZM10.08 9.92a.48.48 0 0 0-.1-.76c-2.41-1.38-4.84-1.59-6.12-.3A3.13 3.13 0 0 0 3 11l-.71 5.44a.5.5 0 0 0 .85.42l2.53-2.53c.16-.16.19-.4.08-.6-.27-.52-.47-1.01-.59-1.47-.35-1.27-.05-1.82.11-1.99.17-.16.72-.46 2-.11.45.12.94.32 1.46.6.2.1.44.07.6-.1l.75-.74ZM7.56 21.71a.5.5 0 0 1-.42-.85l2.53-2.53c.16-.16.4-.19.6-.08.52.27 1.01.47 1.47.59 1.27.35 1.82.05 1.99-.11.16-.17.46-.72.11-2a7.26 7.26 0 0 0-.6-1.46.52.52 0 0 1 .1-.6l.74-.75c.22-.22.6-.18.76.1 1.38 2.41 1.59 4.84.3 6.12-.54.54-1.28.82-2.14.86l-5.44.71ZM7.05 3.32a1 1 0 0 1 1.9-.64l1 3a1 1 0 0 1-1.9.64l-1-3ZM20.68 16.95a1 1 0 0 0 .64-1.9l-3-1a1 1 0 0 0-.64 1.9l3 1ZM22.7 2.7a1 1 0 0 0-1.4-1.4l-20 20a1 1 0 1 0 1.4 1.4l20-20Z"
        className={colorClass}
      />
    </svg>
  );
};
